export default __webpack_public_path__ + "static/media/email.75732195.svg";